import React from 'react'
import PropTypes from 'prop-types'
import { StaticQuery, graphql } from 'gatsby'
import { Global } from '@emotion/core'
import { ThemeProvider } from 'emotion-theming'

import theme from '../utils/theme'
import { Box } from './system'
import Header from './header'
import Footer from './footer'

// Import Spectral
import 'typeface-spectral'

// Import Futura PT
// Original fonts/license for gatsbyjs.org:
// Futura PT Roman + Demi (Regular + Italic)
// fontspring.com
import '../fonts/futura-pt/book/book.css'
import '../fonts/futura-pt/book/bookitalic.css'
import '../fonts/futura-pt/demi/demi.css'
import '../fonts/futura-pt/demi/demiitalic.css'
// Futura PT Bold
// myfonts.com
import '../fonts/futura-pt/bold/MyFontsWebfontsKit.css'

const Layout = ({ children, background }) => (
  <StaticQuery
    query={graphql`
      query SiteTitleQuery {
        site {
          siteMetadata {
            title
          }
        }
      }
    `}
    render={data => (
      <ThemeProvider theme={theme}>
        <Global
          styles={{
            html: {
              fontFamily: theme.fonts.sansSerif,
              scrollBehavior: 'smooth',
            },
            body: {
              color: theme.colors.grey['900'],
              lineHeight: theme.lineHeights.copy,
              margin: 0,
            },
            'h1, h2, h3, h4, h5, h6': {
              fontFamily: theme.fonts.brand,
              // Futura PT Demi as "bold"
              fontWeight: 700,
              lineHeight: theme.lineHeights.title,
            },
            h1: {
              // Futura PT Bold as "bolder"
              fontWeight: 800,
            },
            a: {
              color: theme.colors.blue['500'],
            },
            p: {
              marginTop: 0,
              marginBottom: '1em',
            },
            'tt, code, kbd': {
              fontFamily: theme.fonts.monospace,
              fontSize: '90%',
            },
            '.ReactModal__Overlay': {
              opacity: 0,
              transform: 'translateY(100%)',
              transition: 'all 300ms ease-in-out',
            },
            '.ReactModal__Overlay--after-open': {
              opacity: 1,
              transform: 'translateY(0%)',
            },
            '.ReactModal__Overlay--before-close': {
              opacity: 1,
              transform: 'translateY(100%)',
            },
          }}
        />
        <Box bg="white.900" position="relative">
          {background && background}
          <Header siteTitle={data.site.siteMetadata.title} />
          {children}
        </Box>
        <Footer />
      </ThemeProvider>
    )}
  />
)

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
